import { createFileRoute, Outlet } from "@tanstack/react-router";
import { IntegrationTabs } from "@/components/views/integrations/IntegrationTabs";

export const Route = createFileRoute("/integrations")({
  component: IntegrationsLayout,
});

function IntegrationsLayout() {
  return (
    <div className="flex h-full min-w-0 flex-col overflow-hidden">
      <IntegrationTabs />
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
